import React from 'react';

import { ActiveUploads, IconInfoCircle } from '@trqk/components';
import { locale } from '@trqk/utils';

import { ActiveDetectionUploadEmptyState } from '..';
import { StepWrapper } from '../../../..';
import { progressBarWidth } from '../../../../../constants';

interface ActiveDetectionUploadsProps {
    context: GapAnalysisContext;
    height: number;
    inProgressTasks: UploadStatementTask[];
    remove(removeModalInput: RemoveModalInput): void;
    send: SendGapAnalysisEvent;
}

export const ActiveDetectionUpload = ({
    context,
    height,
    inProgressTasks,
    remove,
    send,
}: ActiveDetectionUploadsProps): JSX.Element => (
    <StepWrapper context={context} remove={remove} send={send}>
        <div className="pt-24">
            <p className="text-center text-sm text-tertiary-400 italic mb-6">
                <IconInfoCircle fillColor="primary-500" width={20} />{' '}
                {
                    locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.UPLOAD_DETECTIONS
                        .DETECTION_DATA_IS_UPLOADING
                }
            </p>
            <ActiveUploads
                height={height}
                inProgressTasks={inProgressTasks}
                emptyState={<ActiveDetectionUploadEmptyState />}
                rowSize={{
                    width: progressBarWidth,
                }}
            />
        </div>
    </StepWrapper>
);
